import { ArrowRight } from '@drift-labs/icons';
import Button from 'src/components/primitives/Button/Button';
import Input from 'src/components/primitives/Input/Input';
import usePrivyEmailInput from 'src/components/Modals/Onboarding/ConnectWalletModal/ConnectWalletModalPrivyOptions/hooks/usePrivyEmailInput';

interface Props {
	email: string;
	setEmail: (email: string) => void;
	onLoginWithPrivyEmail: () => void;
	otpResendSecondsRemaining: number;
}

export default function PrivyEmailInput({
	email,
	setEmail,
	onLoginWithPrivyEmail,
	otpResendSecondsRemaining,
}: Props) {
	const {
		emailError,
		isSendingCode,
		isSendCodeButtonDisabled,
		handleChange,
		handleKeyDown,
		handleBlur,
		handleSendCode,
	} = usePrivyEmailInput({
		email,
		setEmail,
		onLoginWithPrivyEmail,
		otpResendSecondsRemaining,
	});

	return (
		<Input
			id="privy-email-input"
			size="md"
			type="email"
			labelVariant="none"
			placeholder="Enter your email"
			value={email}
			onChange={handleChange}
			onKeyDown={handleKeyDown}
			onBlur={handleBlur}
			suffixClassName="py-sm"
			suffix={
				<Button
					size="sm"
					onClick={handleSendCode}
					disabled={isSendCodeButtonDisabled}
					isLoading={isSendingCode}
					rightIcon={ArrowRight}
				>
					Next
				</Button>
			}
			error={emailError}
		/>
	);
}
